import React, { useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Cookies from 'js-cookie';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Professionaluserview from './Professionaluserview';
import Normaluserview from './Normaluserview';

function Userview() {
    let navigate = useNavigate();
    const { isAuthorized, handleUnauthorized } = useAuthHandling();

    const tokens = Cookies.get("a_token");
    if (!tokens) {
        navigate("/");
    }
    let { id } = useParams();
    const location = useLocation();
    const type = location?.state?.type;
    const [usertype, setUsertype] = useState(type && type === "2type" ? 'professional' : type==='professional-user'?'professional':type==='normal-user'?'normal':"");

    return (
        <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        {type === '2type' ?
                            <div className='row'>
                                <div className='user_view_head'>
                                    <div className={usertype === 'professional' ? 'user_view_head_list active' : "user_view_head_list"} onClick={(e) => setUsertype('professional')}>
                                        Professional User
                                    </div>
                                    <div className={usertype === 'normal' ? 'user_view_head_list active' : "user_view_head_list"} onClick={(e) => setUsertype('normal')}>
                                        Normal User
                                    </div>
                                </div>
                            </div>
                            : ""}

                            {usertype==='professional'?
                            <Professionaluserview id={id}/>
                            :    usertype==='normal'?
                            <Normaluserview id={id}/>
                            :""
                        }
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Userview
